module.exports = __webpack_public_path__ + "media/images/countryrect/ga-1b32f9c1896fe17439541fb21fadb740.svg";